import React from 'react';
import classnames from 'classnames';

import { makeStyles } from '@material-ui/core/styles';
import { Paper } from '@material-ui/core';
import { Icon } from '@hydra/common/components';
const useStyles = makeStyles(theme => ({
  filter: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1.5, 2),
    border: `1px solid ${theme.palette.grey[200]}`,
    borderBottom: 'none',
    borderRadius: `${theme.shape.borderRadius * 2.5}px ${theme.shape.borderRadius * 2.5}px 0 0`
  },
  icon: {
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(2)
  }
}));

export default function FilterContainer ({ children, ...props }) {
  const classes = useStyles();

  return (
    <Paper elevation={0} className={classnames(classes.filter, 'nr-filter-toolbar')}>
      <div className={classes.icon}>
        <Icon type='filter' size='md' />
      </div>
      {children}
    </Paper>
  );
}
